import { render, staticRenderFns } from "./UserAccessRestrictionForm.vue?vue&type=template&id=3695b900&"
import script from "./UserAccessRestrictionForm.vue?vue&type=script&lang=js&"
export * from "./UserAccessRestrictionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports